"use client";

import { useEffect, useState } from "react";

export const BlogNavira = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);

    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % 2); // 2 slides
    }, 6000); // change toutes les 6 secondes

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      style={{
        minHeight: "auto",
        padding: "40px 20px",
        background: "linear-gradient(135deg, #97bfe7ff, #eef2ff)",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div style={{ maxWidth: "1150px", width: "100%" }}>

        {/* DIAPORAMA */}
        <div style={{ overflow: "hidden", position: "relative" }}>
          <div
            style={{
              display: "flex",
              transform: `translateX(-${index * 100}%)`,
              transition: "transform 0.8s ease-in-out",
            }}
          >

            {/* ===== SLIDE 1 : Code With Navira ===== */}
            <div style={{ minWidth: "100%" }}>
              <h1 style={{ fontSize: "42px", textAlign: "center", fontWeight: "900" }}>
                🎓 Bienvenue sur <span style={{ color: "#2563eb" }}>Code With Navira</span>
              </h1>
              <p style={{ textAlign: "center", fontSize: "20px", marginBottom: "30px" }}>
                Formations gratuites en Symfony, PHP, API Platform, Next.js et plus encore 🚀
              </p>

              <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", alignItems: "center" }}>
                <div style={{ flex: "1 1 320px" }}>
                  <h2 style={{ fontSize: "30px", fontWeight: "800" }}>
                    📚 Accédez directement aux formations
                  </h2>
                  <p style={{ fontSize: "20px", lineHeight: "1.6" }}>
                    Retrouvez toutes les vidéos et ressources sur ma plateforme.
                  </p>
                  <a
                    href="https://blog.antonionavira.mg/"
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      display: "inline-block",
                      marginTop: "18px",
                      padding: "12px 18px",
                      background: "#2563eb",
                      color: "white",
                      borderRadius: "10px",
                      textDecoration: "none",
                      fontWeight: "bold",
                    }}
                  >
                    👉 Aller au Code With Navira
                  </a>
                </div>

                <div style={{ flex: "1 1 320px" }}>
                  <iframe
                    width="100%"
                    height="330"
                    src="https://www.youtube.com/embed/0x-ykr8wKfQ?autoplay=1&mute=1&loop=1&playlist=0x-ykr8wKfQ"
                    title="Code With Navira"
                    frameBorder="0"
                    allow="autoplay; encrypted-media"
                    allowFullScreen
                    style={{ borderRadius: "14px" }}
                  />
                </div>
              </div>
            </div>

            {/* ===== SLIDE 2 : Ndao hamaky Baiboly ===== */}
            <div style={{ minWidth: "100%" }}>
              <h1 style={{ fontSize: "42px", textAlign: "center", fontWeight: "900" }}>
                📖 Ndao hamaky <span style={{ color: "#16a34a" }}>Baiboly</span>
              </h1>
              <p style={{ textAlign: "center", fontSize: "20px", marginBottom: "30px" }}>
                Un verset biblique en malagasy envoyé chaque jour par email 🇲🇬
              </p>

              <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", alignItems: "center" }}>
                <div style={{ flex: "1 1 320px" }}>
                  <h2 style={{ fontSize: "30px", fontWeight: "800" }}>
                    🙏 La Parole chaque jour
                  </h2>
                  <p style={{ fontSize: "20px", lineHeight: "1.6" }}>
                    Reçois chaque matin un verset biblique en langue malagasy, directement dans ta boîte mail.
                    Vous trouverez aussi des api pour recupererer les versets.
                  </p>

                  <a
                    href="https://baiboly.antonionavira.mg"
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      display: "inline-block",
                      marginTop: "18px",
                      padding: "12px 18px",
                      background: "#16a34a",
                      color: "white",
                      borderRadius: "10px",
                      textDecoration: "none",
                      fontWeight: "bold",
                    }}
                  >
                    👉 Découvrir Ndao hamaky Baiboly
                  </a>
                </div>

                <div style={{ flex: "1 1 320px" }}>
                  <iframe
                    width="100%"
                    height="330"
                    src="https://www.youtube.com/embed/ztzIGYCfWCE?autoplay=1&mute=1&loop=1&playlist=ztzIGYCfWCE"
                    title="Ndao hamaky Baiboly"
                    frameBorder="0"
                    allow="autoplay; encrypted-media"
                    allowFullScreen
                    style={{ borderRadius: "14px" }}
                  />
                </div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};
